export default __webpack_public_path__ + "static/media/newsimg3.0bea154b.webp";